export const EnumSortField = {
    ID: 'ID',
    WHOLESALER: 'WHOLESALER',
    CREATED_AT: 'CREATED_AT',
    CLIENT_IDENTIFICATION: 'CLIENT_IDENTIFICATION',
    WHOLESALER_BRANCH_NAME: 'WHOLESALER_BRANCH_NAME',
    STATUS: 'STATUS',
} as const;
